import { IOeDataOrganizationDTO, IOeDataOrganizationsDAO, IOeDataOrganizationsRequestParams } from '../oe-data-organizations.dao';
import { IPaginatedContentResponse } from '../shared.dto';
import { OE_DATA_ORGANIZATIONS_MOCK } from './oe-data-organizations.mock';

export class OeDataOrganizationsDAO extends IOeDataOrganizationsDAO {
    public async getOrganizations(params: IOeDataOrganizationsRequestParams): Promise<IPaginatedContentResponse<IOeDataOrganizationDTO>> {
        const { page, size } = params;
        const organizations = OE_DATA_ORGANIZATIONS_MOCK;
        const content = organizations.slice(page * size, (page + 1) * size);
        const totalPages = Math.ceil(organizations.length / size);

        return {
            content: content,
            totalElements: organizations.length,
            totalPages: totalPages,
            size: size,
            // eslint-disable-next-line id-denylist
            number: page,
            first: page === 0,
            last: page >= totalPages - 1,
            numberOfElements: content.length,
            empty: !content.length,
        };
    }
}
